"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
exports.ContentRootId = "zl-content-root";
exports.ModalRootId = "zl-modal-root";
exports.TooltipRootId = "zl-tooltip-root";
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 100%;\n\t", "\n"], ["\n\twidth: 100%;\n\theight: 100%;\n\t", "\n"])), function (props) { return props.theme.pageRoot; });
var PageRoot = /** @class */ (function (_super) {
    __extends(PageRoot, _super);
    function PageRoot(props) {
        var _this = _super.call(this, props) || this;
        _this.onModalChange = function () {
            _this.setState({ hasModal: (_this.modalRoot.current && _this.modalRoot.current.childElementCount > 0) || false });
        };
        _this.state = {
            hasModal: false
        };
        _this.modalRoot = react_1.default.createRef();
        if (typeof MutationObserver !== 'undefined') {
            _this.modalObserver = new MutationObserver(_this.onModalChange);
        }
        else {
            console.error("MutationObserver undefined");
        }
        return _this;
    }
    PageRoot.prototype.componentDidMount = function () {
        if (this.modalObserver) {
            this.modalObserver.observe(this.modalRoot.current, { childList: true });
        }
    };
    PageRoot.prototype.componentWillUnmount = function () {
        if (this.modalObserver) {
            this.modalObserver.disconnect();
        }
    };
    PageRoot.prototype.render = function () {
        return (react_1.default.createElement(Root, null,
            react_1.default.createElement("div", { id: exports.ContentRootId, style: { overflow: this.state.hasModal ? 'hidden' : undefined, height: '100%' }, inert: this.state.hasModal ? 'true' : undefined }, this.props.children),
            react_1.default.createElement("div", { id: exports.ModalRootId, ref: this.modalRoot, style: { position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, pointerEvents: 'none', zIndex: 1000 } }),
            react_1.default.createElement("div", { id: exports.TooltipRootId, style: { position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, pointerEvents: 'none', zIndex: 2000 } })));
    };
    return PageRoot;
}(react_1.Component));
exports.PageRoot = PageRoot;
exports.default = styled_components_1.withTheme(PageRoot);
var templateObject_1;
//# sourceMappingURL=PageRoot.js.map